import { IonRouterOutlet, IonHeader, IonToolbar, IonTitle, IonRedirect, IonRouterLink } from '@ionic/react';
import React, { useState, useContext, useEffect } from 'react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";


import { RouteComponentProps, useHistory } from 'react-router';

import { Plugins } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences'


import { Auth_Zasava_Context }  from '../../../storeState/Auth_Zasava_Context'

const { Storage } = Plugins;



async function removeStorageCredentials() {


    await Preferences.remove({ key: 'accountID' });
    await Preferences.remove({ key: 'employeeID' });
    await Preferences.remove({ key: 'employee_first_name' });
    await Preferences.remove({ key: 'employee_last_name' });
    await Preferences.remove({ key: 'employee_company' });
    await Preferences.remove({ key: 'employee_createdBy' });
    await Preferences.remove({ key: 'schemaName' });
    await Preferences.remove({ key: 'isAuthenticated' });
    await Preferences.remove({ key: 'accessRights' });
    await Preferences.remove({ key: 'loginUsername_authenticated' });
    await Preferences.remove({ key: 'loginPassword_authenticated' });
    await Preferences.remove({ key: 'isBiometricFingerprintAvilable' });
    await Preferences.remove({ key: 'biometricFingerprint' });
    await Preferences.remove({ key: 'device' });
    await Preferences.remove({ key: 'sessionID' });
    await Preferences.remove({ key: 'baseURL' });
    await Preferences.remove({ key: 'capability' });
    await Preferences.remove({ key: 'feature' });

}

export function ConfirmMerchantLogout (){

    let authenticatedMerchent_context = useContext(Auth_Zasava_Context);

    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [logoutSuccess, setLogoutSuccess] = useState(false);


    let history = useHistory();

    useEffect(() => { 


        //alert("In Logout use effect");
        //alert(baseURL);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                user: authenticatedMerchent_context.acctID,
                schema: authenticatedMerchent_context.schema,
                sessionID: authenticatedMerchent_context.sessionID,

            })
        }

        fetch(baseURL+'merchantAcct_argsjqApp_logout', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert(data);

            if(data == '1')
            {

               // alert('LOG OUT SUCCESSFULL');

                removeStorageCredentials();
                //setLogoutSuccess(true);


                authenticatedMerchent_context.changeAccountID(null);
                authenticatedMerchent_context.changeEmployeeID(null);
                authenticatedMerchent_context.changeSchema(null);
                authenticatedMerchent_context.changeEmployeeCreatedBy(null);
                authenticatedMerchent_context.changeAccessRights([null, null, null, null, null]);
                authenticatedMerchent_context.changeCookieID(null);
                authenticatedMerchent_context.changeAuthenticated(null);
                authenticatedMerchent_context.changeLoginUsername(null);
                authenticatedMerchent_context.changeLoginPassword(null);
            
                authenticatedMerchent_context.changeIsBiometric_fingerprintAvilable(false);
                authenticatedMerchent_context.changeBiometric_fingerprint(false);
                authenticatedMerchent_context.changeDevice('desktop');
            
                authenticatedMerchent_context.changeStartDateRange(new Date());
                authenticatedMerchent_context.changeEndDateRange(new Date());
                authenticatedMerchent_context.changeNumOfNights(null);

            
                history.push('/home');
                window.location.reload(); 


                //return;
            }
            else
            {

                alert('LOG OUT - NOT - SUCCESSFULL');
                removeStorageCredentials();
                authenticatedMerchent_context.changeAuthenticated(null);
                //setLogoutSuccess(true);
                history.push('/home');
                window.location.reload(); 

                //return;

            }

        })
        .catch(error => {
            console.error(error);
        })

    }, [])

    //alert('In Logout');
    //alert(logoutSuccess);


        return(
                <React.Fragment>
                    {/*{ logoutSuccess &&  <Redirect to='/' /> }
                    {/* !logoutSuccess &&  <Redirect to='/' /> */}
                </React.Fragment>
            )  
}
    

export default ConfirmMerchantLogout;